import { Node, mergeAttributes } from '@tiptap/core';

export const CustomVideo = Node.create({
  //* 노드 이름 설정
  name: 'video',

  //* 노드의 그룹 설정
  group: 'block',

  //* 이 노드는 아톰(atomic) 노드로, 노드 내의 내용을 편집할 수 없습니다.
  atom: true,

  //* 노드가 가질 수 있는 속성을 추가
  addAttributes() {
    return {
      //* 비디오의 소스 경로를 나타내는 'src' 속성입니다. 기본값은 null입니다.
      src: {
        default: null,
      },
      //* 비디오의 제어 여부를 나타내는 'controls' 속성입니다. 기본값은 true입니다.
      controls: {
        default: true,
      },
    };
  },

  //* HTML을 파싱할 때 이 노드가 어떤 태그를 기반으로 생성될지를 정의합니다.
  parseHTML() {
    return [
      {
        //* 'src' 속성이 있는 'video' 태그를 찾습니다.
        tag: 'video[src]',
      },
    ];
  },

  //* 노드를 HTML로 렌더링할 때 사용할 태그와 속성을 정의합니다.
  renderHTML({ HTMLAttributes }) {
    return [
      'video',
      //* 노드의 기본 HTML 속성과 전달받은 HTML 속성을 병합합니다.
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
    ];
  },

  //* 노드가 실제로 DOM에 렌더링될 때의 뷰를 정의합니다.
  addNodeView() {
    return ({ node }) => {
      const video = document.createElement('video');
      video.src = node.attrs.src;
      video.controls = node.attrs.controls;

      return {
        dom: video, //* dom 속성은 실제 DOM 요소를 참조합니다.
      };
    };
  },
});
